import { inject, Injectable, signal } from "@angular/core";
import { AppConfig } from "../config/app.config";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { BehaviorSubject, of, Subject } from "rxjs";
import { DefaultMessages, IndicationRiskSummary, LossPayeeTypeList, PortalRating, quoteComparison, quoteComparisonResponce, QuoteRiskSummary, SaveIndicationAndHomeResponse, SLLicenseTypeList, StepIdListResponse } from "../models/RequestQuote";
import { Router } from "@angular/router";
import { AuthService } from "../auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class IndicationQuoteStepService{
    private apiUrl = AppConfig.apiUrl;
    authservice = inject(AuthService)       
    private token = this.authservice.getToken()
    httpClient = inject(HttpClient);
    router = inject(Router);

    private quoteCompariosnPopUp$ = new Subject<quoteComparison>();
    quoteList = signal<quoteComparisonResponce | null>(null);

    getQuoteCompsrisonResponce()
    {
        return this.quoteList();
    }

    setQuoteCompsrisonResponce( list : quoteComparisonResponce)
    {
         this.quoteList.set(list);
    }
     
    
    addQuoteComparison(quoteComparisonDetails: quoteComparison){
        // this.resetData()
        this.quoteCompariosnPopUp$.next(quoteComparisonDetails);
    }

    getQuoteComparisonDetails(){
        return this.quoteCompariosnPopUp$.asObservable();
    }

    resetData() {
        this.quoteCompariosnPopUp$.complete();
        this.quoteCompariosnPopUp$ = new Subject<any>();
     } 
      


    fetchIndicationQuoteStepRagDetails(){
        const response = {
            namedInsured: "Alchemy UnderWriting", tiv: "12025874", QuoteNo: "Quote12054", Status: "InProgress",
            QuoteFeedbackMessage: "If you don't have any referrals, please continue to the next step and get the quote issued",
            targetPremiumMessage: "Your target price is slightly off. Please review.", feedbackType: "green", isReferral: false, 
        }
        return of(response);
    }

    getIndicationRating(indicationId: number, userId: number) {
        const path=`/api/IndicationRating/CalculateRAGId?IndicationId=${indicationId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<PortalRating>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    getQuoteRating(quoteId: number, userId: number) {
        const path=`/api/Quote/CalculateRAGId?quoteId=${quoteId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<PortalRating>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    getPolicyRating(policyId: number){
        const path=`/api/Policy/CalculateRAGId?PolicyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<PortalRating>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    getQuoteFeedbackMessage(msgId: number) {
        const path=`/api/DefaultMessages/${msgId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<DefaultMessages>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getIndicationRiskSummary(indicationId: number) {
        const path=`/api/Indication/GetIndicationRiskSummary?indicationId=${indicationId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<IndicationRiskSummary>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getQuoteRiskSummary(quoteId: number) {
        const path=`/api/Quote/GetQuoteRiskSummary?quoteId=${quoteId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<QuoteRiskSummary>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getPolicyRAG(id: number, type: string) {
        const path=`/api/Policy/GetRAGByID?id=${id}&type=${type}`
        const encodedPath = encodeURIComponent(path);
        const url = `${this.apiUrl}/Proxy?path=${encodedPath}`;
        return this.httpClient.get(url);
      }

    saveIndicationAndHome(indicationId: number, branchId: number, userId: number) {
        const path=`/api/Indication/SaveIndicationAndHome?indicationId=${indicationId}&branchId=${branchId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }
    
    saveQuoteAndHome(quoteId: number, branchId: number, userId: number) {
        const path=`/api/Quote/SaveQuoteAndHome?quoteId=${quoteId}&branchId=${branchId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    saveStepIndication(step: string, type: string, id: string){
        const path=`/api/Quote/SaveStep?step=${step}&type=${type}&id=${id}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    saveStepforUWadmin(step: string, type: string, id: string){
        const path=`/api/UWAdminReview/SaveUWAdminStep?step=${step}&type=${type}&id=${id}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    saveStepForCurrentUser(step: string, type: string, id: string){
        return this.authservice.isUwAdmin()
            ? this.saveStepforUWadmin(step, type, id)
            : this.saveStepIndication(step, type, id);
    }

    submitReferral(){
        return of(true);
    }

    submitReferal(indicationId: number, branchId: number){
        const path=`/api/Indication/SubmitIndicationReferral?indicationId=${indicationId}&branchId=${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    submitReferralQuote(quoteId: number, branchId: number){
        const path=`/api/Quote/SubmitQuoteReferral?quoteId=${quoteId}&branchId=${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    InceptionStatusList(){
        const path = `api/Quote/GetInceptionRefStatus`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`)
    }

    SubmitReferralInceptionDate(quoteId: number, branchId: number, status: string, versionNo: number){
        const path = `api/Quote/SubmitInceptionReferral?quoteId=${quoteId}&branchId=${branchId}&status=${status}&versionNo=${versionNo}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`,null);  
    }
    
    fetchIndicationCoverageSummaryDetails(indicationId: number, branchId: number){  
        const path=`/api/Indication/GetIndicationCoverageSummary?indicationId=${indicationId}&branchId=${branchId}`
        const encodedPath = encodeURIComponent(path); 
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    fetchQuoteCoverageSummaryDetails(quoteId: number, branchId: number){   
        const path=`/api/Quote/GetQuoteCoverageSummary?quoteId=${quoteId}&branchId=${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    requestQuoteSummaryDetails() {
        return of(true);
    }

    acceptAndIssueQuote(){
        return of(true);
    }

    

    getDocumentForViewAndDownload() {
        //return this.http.get(this.apiUrl, { responseType: 'blob' });
        return of(true);
    }

    requestBind() {
        return of(true);
    }

    fetchStepIdList() {
        const path=`/api/UWAdmin/GetStepList`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<StepIdListResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    approveIndication(indicationId: number, userId: number) {
        const path=`/api/UWAdminReview/ApproveReferral?indicationId=${indicationId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    denyIndication(indicationId: number, userId: number) {
        const path=`/api/UWAdminReview/DenyReferral?indicationId=${indicationId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    amendIndicationByUWAdmin(indicationId: number, userId: number) {
        const path=`/api/UWAdminReview/AmendReferral?indicationId=${indicationId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    submitIndication(indicationId: number, userId: number){
        const path=`/api/UWAdminReview/SubmitIndicationChanges?indicationId=${indicationId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    approveQuote(quoteId: number, userId: number) {
        const path=`/api/UWAdminReview/ApproveQuoteReferral?QuoteId=${quoteId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    denyQuote(quoteId: number, userId: number) {
        const path=`/api/UWAdminReview/DenyQuoteReferral?QuoteId=${quoteId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    amendQuoteByUWAdmin(quoteId: number, userId: number) {
        const path=`/api/UWAdminReview/AmendQuoteReferral?QuoteId=${quoteId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    SaveUWAdminAmendment(payload : any){
        const path=`/api/UWAdminReview/SaveUWAdminAmendment`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    GetAmendmentDetails(transactionType : string, transactionId : number, amendmentVersion : number){
        const path=`/api/UWAdminReview/GetAmendmentDetails?transactionType=${transactionType}&transactionId=${transactionId}&amendmentVersion=${amendmentVersion}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    UpdateUWAdminAmendment(payload : any){
        const path=`/api/UWAdminReview/UpdateUWAdminAmendment`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }   

    submitQuote(quoteId: number, userId: number){
        const path=`/api/UWAdminReview/SubmitQuoteChanges?indicationId=${quoteId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    amendIndicationByBroker(indicationId: number, branchId: number) {
        const path=`/api/Indication/PostAmendIndication?indicationId=${indicationId}&branchId=${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    submitAndIssueQuote(indicationId: number, userId: number) {
        const path=`/api/Indication/SaveQuoteData?indicationId=${indicationId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<HttpResponse<any>>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null, { observe: 'response' });
    }

    UpdateQuoteData(quoteId: number){
        const path = `/api/Quote/UpdateQuoteDate?quoteId=${quoteId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<HttpResponse<any>>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null, { observe: 'response' });
    }

    amendQuoteByBroker(quoteId: number, branchId: number) {
        const path=`/api/Quote/PostAmendQuote?quoteId=${quoteId}&branchId=${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    fetchBindIssuePolicyDetails(quoteId: number, userId: number, versionId: number) {
        const path=`/api/Policy/GetQuoteLossDetails?quoteId=${quoteId}&userId=${userId}&versionId=${versionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    saveBindIssuePolicyDetails(payload: any, quoteId: number,versionId: number, userId: number) {
        const path=`/api/Policy/SaveQuoteLossDetails?quoteId=${quoteId}&userId=${userId}&versionId=${versionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    savePolicyDetails(quoteId: number, userId: number, versionId: number) {
        const path=`/api/Policy/SavePolicyData?quoteId=${quoteId}&userId=${userId}&versionId=${versionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    GetQuoteDateDetails(quoteNo: string){
        const path = `/api/Quote/GetQuoteDateDetails?quoteNo=${quoteNo}`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getBindIssuePolicyClearanceAddress(quoteId: number, versionId: number){ 
        const path=`/api/Policy/GetQuoteAddress?quoteId=${quoteId}&versionNo=${versionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getClearanceAddressForPolicy(policyId: number){
        const path=`/api/Policy/GetPolicyAddress?policyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getBindIssuePolicyLossPayeeType(){
        const path=`/api/Policy/GetLossPayeeList`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<LossPayeeTypeList[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getSLLicenseList(userId:number){
        const path=`/api/Policy/GetSLLicenseNumber?userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<SLLicenseTypeList[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    GetSLLicenseNumberByState(id: number, type: string, companyId?: number){
        const path=`/api/Policy/GetSLLicenseNumberByState?id=${id}&type=${type}&companyId=${companyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    GetCompanyBranchAddresses(quoteId: number) {
        const path = `/api/Quote/GetCompanyBranchAddresses?quoteId=${quoteId}`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    saveBindIssuePolicyDetailsByPolicyId(payload: any, policyId: number, userId: number){
        const path=`/api/Policy/SavePolicyLossDetails?policyId=${policyId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    fetchBindIssuePolicyDetailsByPolicyId(policyId: number, userId: number) {
        const path=`/api/Policy/GetPolicyLossDetails?policyId=${policyId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }
    
    setSelectedQuoteVersion(quoteDetails: any) {
        const selectedQuoteVersion = {quoteId: quoteDetails.quoteId, versionNo: quoteDetails.versionNo};
        sessionStorage.setItem('selectedQuoteVersion', JSON.stringify(selectedQuoteVersion));
    }
  
    getSelectedQuoteVersion(){
        const storedData = sessionStorage.getItem('selectedQuoteVersion');
        const selectedQuoteVersion = storedData ? JSON.parse(storedData) : null;
        return selectedQuoteVersion;
    }

    setPolicyId(policyId: number) {
        sessionStorage.setItem('policyId', String(policyId));
    }

    requestMTAChange(payload: any) {
        const path=`/api/Indication/PostAmendIndication`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    declineChangeRequestMTA() {
        const path=`/api/UWAdminReview/DenyQuoteReferral`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    quoteMTA() {
        const path=`/api/Quote/PostAmendQuote`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post<SaveIndicationAndHomeResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    IndicationInspectionFees(indicationId : number) {
        const path=`/api/IndicationRating/CalculateOtherFees?indicationId=${indicationId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    QuoteInspectionFees(quoteId : number) {
        const path=`/api/Quote/CalculateOtherFees?QuoteId=${quoteId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    PolicyInspectionFees(policyId : number) {
        const path=`/api/Policy/CalculateOtherFees?PolicyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    GetSurplusLinesTaxFee(){
        const path=`/api/Indication/GetSurplusLinesTaxFee`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    SaveIndicationSLFeeDetails(indicationId: number, userId: number, payload: any){
        const path =`/api/Indication/SaveIndicationSLFeeDetails?id=${indicationId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    GetIndicationSLFeeDetails(indicationId: number){
        const path=`/api/Indication/GetIndicationSLFeeDetails?indicationId=${indicationId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    SaveQuoteSLFeeDetails(quoteId: number, userId: number, payload: any){
        const path =`/api/Quote/SaveQuoteSLFeeDetails?id=${quoteId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    GetQuoteSLFeeDetails(quoteId: number){
        const path=`/api/Quote/GetQuoteSLFeeDetails?quoteId=${quoteId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    GetPolicySLFeeDetails(policyId: number){
        const path=`/api/Policy/GetPolicySLFeeDetails?policyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    GetEQBDOccupanyDetails(id: number, type: string){
        const path=`api/Clearance/GetEQBDOccupanyDetails?id=${id}&type=${type}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    SaveIndicationEQBDCoverages(indicationId: number, payload: any){
        const path=`api/Indication/SaveIndicationEQBDCoverages?indicationId=${indicationId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    GetIndicationEQBDCoverages(indicationId: number){
        const path=`api/Indication/GetIndicationEQBDCoverages/${indicationId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    SaveQuoteEQBDCoverages(quoteId: number, VersionId: number, payload: any){
        const path=`api/Quote/SaveQuoteEQBDCoverages?quoteId=${quoteId}&VersionId=${VersionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    GetQuoteEQBDCoverages(quoteId: number,VersionId: number){ 
        const path=`api/Quote/GetQuoteEQBDCoverages/${quoteId}?VersionId=${VersionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    GetPolicyEQBDCoverages(policyId: number){   
        const path=`api/Policy/GetPolicyEQBDCoverages/${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    GetEqbdTriaStatus(quoteId: number, eqbd: boolean, tria: boolean, versionId: number){
        const path=`api/Quote/GetEqbdTriaStatus?quoteId=${quoteId}&eqbd=${eqbd}&tria=${tria}&versionId=${versionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    GetEQBDReferralDetails(id: number, type: string){
        const path = `/api/Clearance/GetEQBDReferralDetails?id=${id}&type=${type}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    UpdateEQBDReferralApproval(payload: any){
        const path = `/api/UWAdminReview/UpdateEQBDReferralApproval`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    GetStep4DQuoteEQBD(quoteId: number, versionId: number){
        const path = `/api/Quote/GetStep4DQuoteEQBD/${quoteId}?VersionId=${versionId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    setPolicyID(policyId: string) {
        sessionStorage.setItem('policyId', policyId);
    }

    redirectToDashboard() {
        this.removeIndicationQuoteStorageData(); // clear the storage data
        this.router.navigate(['/quote']); // redirect to dashboard
    }


    
    /**
     * Clears workflow cache APIs and session workflow keys.
     * @param onComplete Runs after server cache remove and session key cleanup (use to set new workflow state).
     * @param options includeTemp=false skips temp cache DELETE API.
     */
    removeIndicationQuoteStorageData(
      onComplete?: () => void,
      options: { includeTemp?: boolean } = {}
    ){
       const clearIndicationRecords = ['tempQuoteId', 'quoteId', 'quoteType', 'quoteAddressId', 'quoteNumber', 'quoteDetails', 'indicationId',
        'nameInsured', 'indicationNo', 'indicationStatus', 'indicationAddressId', 'isAmendByUWAdmin', 'currentStepId','statusId',
        'isReview', 'versionNo', 'id', 'buildingid', 'copeInfosave', 'clearanceInfoSave', 'PolicyInfoSave', 'indicationQuestionId', 'tiv',
        'isPolicyType','addressTypeId','quoteStatus','quoteReferralLock','quoteQuestionId','quoteNo', 'indicationBindStepId', 'selectedQuoteVersion','otherStructureIds','policyTypeId',
        'policyId','documentIds', 'quoteIdForPolicy', 'policyNo', 'policyDate', 'policyStartDate', 'policyEndDate', 'policyStatus', 'policyAddressId', 'tempQuoteNumber', 'policyQuestionId', 'isQuoteMTA', 'isMTA',
        'clearanceCheck','lock','terms','dtcRule','AmendDisable','requestQuoteDisable','QuoteReferredDeclined','isreferral','statusAvailable','statusRagCall','RagCall','inceptionStatus',"quoteDate","quoteId","quoteVersionBound",
        "inDtMinLimit","inDtValidLimit","inDtMaxLimit","buildingIdforaddress","indicationDraftStatus","quoteDraftStatus"
       ];
       this.authservice.resetWorkflowCaches(() => {
         clearIndicationRecords.forEach((record: string) => sessionStorage.removeItem(record));
         onComplete?.();
       }, options);
    }
}